import { render } from "./Reviews.vue?vue&type=template&id=9d16f768&scoped=true"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"

import "./Reviews.vue?vue&type=style&index=0&id=9d16f768&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d16f768"]])

export default __exports__